import v1en from './v1/en.yml';
import v1pl from './v1/pl.yml';
import v2en from './v2/en.yml';
import v2pl from './v2/pl.yml';

export default {
  en: { ...v1en, ...v2en },
  pl: { ...v1pl, ...v2pl },
};
